<template>
  <div class="RouteContainer">
    <app-background :backgroundImg="'./static/images/' + sharedContent.backgroundImgBlur"/>

    <div class="container">

      <div class="row align-items-center mt-5">
        <div class="col-md-6">
          <img :src="'./static/images/about/' + aboutContent.introImage.fileName" :alt="aboutContent.introImage.title" :title="aboutContent.introImage.title">
        </div>
        <div class="col-md-6">
          <div class="Blurb">
            <h1 class="Blurb-title">{{ aboutContent.title }}</h1>
            <p class="Blurb-body">{{ aboutContent.intro }}</p>
          </div>
        </div>
      </div>

    </div>

    <div class="container-fluid mt-5 Article-wrapper">
      <div class="container">
        <div class="row Article">
          <div class="col-md-8 mx-auto py-3" v-for="(article, i) in aboutContent.articles" :key="i">
            <h2 class="Article-title">{{ article.heading }}</h2>
            <p class="Article-body">
              {{ article.body }} Learn more at <a href="https://www.livingwithwolves.org/" class="LinkInline" target="_blank" rel="noopener">livingwithwolves.org</a>.
            </p>
          </div>
          <div class="col-md-8 mx-auto">
            <p>To purchase the Dutcher’s images visit <a class="LinkInline" href="https://www.livingwithwolves.org/national-geographic/" target="_blank" rel="noopener">National Geographic Creative.</a></p>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import appBackground from './../partials/background'

export default {
  name: 'about',

  components: {
    appBackground
  },

  computed: {
    aboutContent () {
      return this.$store.getters.aboutContent
    },

    sharedContent () {
      return this.$store.getters.sharedContent
    }
  },

  beforeCreate () {
    this.$store.dispatch('getLocalData', 'about')
  }
}
</script>

<style lang="scss" scoped>
@import "./../../assets/_variables.scss";
@import "./../../assets/_base.scss";

.Article-wrapper {
  background: $transparentGray;
}

.Article {
  color: $offwhite;
  font-family: $fontSansSerif;
  padding-top: 2rem;
}

.Article-body {
  @extend .Blurb-body;
}

.Article-title {
  color: $gold;
}
</style>



// WEBPACK FOOTER //
// src/components/routes/about.vue